<template>
	<section class="small-12 columns propertyBalance freeToInvest" v-if="property">
		<div class="small-12 widget border borderRadius8">
			<div class="small-12 wrap">
				<div class="small-12 flex vertical-align">
					<div class="small-12 columns balance border-bottom">
						<p class="small-12 flex">Property Balance</p>
						<h2 class="small-12 flex vertical-align">
							<i class="material-icons-outlined">attach_money</i>
							0.00
						</h2>
					</div>
					<div class="small-12 operationalBreakdown">
						<div class="small-12 columns widgetTitle flex vertical-align">
							<h2 class="small-12 flex vertical-align">
								Operational Breakdown 
								<span class="flex vertical-align small-12" style="margin-top:5px;">This Month</span>
							</h2>
						</div>
						<div class="small-12 stats">
							<ul class="small-12 flex">
								<li class="small-12 columns">
									<div class="small-12 large-5">
										<p>Money In:</p>
									</div>
									<div class="small-12 large-7 flex vertical-align justify-right">
										<i class="material-icons outlined">attach_money</i>
										<span>0.00</span>
									</div>
								</li>
								<li class="small-12 columns">
									<div class="small-12 large-5">
										<p>Money Out:</p>
									</div>
									<div class="small-12 large-7 flex vertical-align justify-right">
										<i class="material-icons outlined cRed">money_off</i>
										<span class="cRed">0.00</span>
									</div>
								</li>
								<li class="small-12 columns border-top flex vertical-align netIncome">
									<div class="small-12 flex justify-between">
										<div class="small-12 large-6">
											<p>Net Income:</p>
										</div>
										<div class="small-12 large-6 flex vertical-align">
											<i class="material-icons outlined">attach_money</i>
											<span>0.00</span>
										</div>
									</div>
									<div class="small-12 flex justify-center action" v-if="future_item">
										<a class="borderRadius4 flex justify-center noFillButton border">View Operations</a>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'PropertyBalance',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false

		}),

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		 /*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>